import { render } from "./MapZoomOut.vue?vue&type=template&id=412e5484&scoped=true&lang=pug"
const script = {}

import "./MapZoomOut.vue?vue&type=style&index=0&id=412e5484&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-412e5484"

export default script